const initialState = () => ({
  countProcesses: 0,
  progress: 0,
  isActive: false
})

const state = initialState()

const actions = {
  start (context, countProcesses) {
    context.commit('START')
    context.commit('COUNT_PROCESSES', countProcesses)
    this._vm.$Progress.set(0)
  },

  updateProgress (context, increasePercentage) {
    let countProcesses = context.getters['countProcesses']
    let currentProgress = context.getters['progress']

    let increaseOn = increasePercentage / countProcesses
    context.commit('PROGRESS', currentProgress + increaseOn)

    this._vm.$Progress.set(currentProgress + increaseOn)
  },

  finish (context) {
    this._vm.$Progress.finish()
    context.commit('FINISH')
    context.commit('COUNT_PROCESSES', 0)
  }
}

const mutations = {
  START (state, progress) {
    state.isActive = true
  },

  FINISH (state, progress) {
    state.progress = 0
    state.isActive = false
  },

  PROGRESS (state, progress) {
    state.progress = progress
  },

  COUNT_PROCESSES (state, count) {
    state.countProcesses = count
  }
}

const getters = {
  progress: state => {
    return state.progress
  },

  countProcesses: state => {
    return state.countProcesses
  },

  isActive: state => {
    return state.isActive
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
